import { BatchRepository, BatchRepositoryError, Batch, BatchFactory } from '@/Domain/Batch'
import { ProcedureId } from '@/Domain/Procedures'
import { ApiClient, Api500Error } from '@/Domain/ApiClient'
import { AxiosBatchData } from './AxiosBatchData'
import { AccountId } from '@/Domain/Account'

export class AxiosBatchRepository implements BatchRepository {
  private _apiClient: ApiClient
  private _batchFactory: BatchFactory<AxiosBatchData>

  constructor (apiClient: ApiClient, batchFactory: BatchFactory<AxiosBatchData>) {
    this._apiClient = apiClient
    this._batchFactory = batchFactory
  }

  async byProcedureId (procedureId: ProcedureId): Promise<Batch[]> {
    try {
      const response = await this._apiClient.makeGetRequest(
        '/sobree/api/batches/' + procedureId.id,
        {}
      )
      const batches = response.data.data.map((current: AxiosBatchData) => {
        return this._batchFactory.makeBatch(current)
      })
      return batches
    } catch (error) {
      if (error instanceof Api500Error) {
        return Promise.reject(new BatchRepositoryError('Server not responding'))
      }
      return Promise.reject(error)
    }
  }

  // eslint-disable-next-line
  async byProcedureIdAndUserIdWithOffers (procedureId: ProcedureId, accountId: AccountId): Promise<Batch[]> {
    try {
      const response = await this._apiClient.makeGetRequest(
        '/sobree/api/batches/withoffers/' + procedureId.id,
        {}
      )
      const batches = response.data.data.map((current: AxiosBatchData) => {
        return this._batchFactory.makeBatch(current)
      })
      return batches
    } catch (error) {
      if (error instanceof Api500Error) {
        return Promise.reject(new BatchRepositoryError('Server not responding'))
      }
      return Promise.reject(error)
    }
  }
}
